import { BatchesFilters } from './BatchesFilters';
import { BATCHES_TITLE_TEST_ID } from './constants';
import type { FiltersState } from './localState';

type Props = {
  filters: FiltersState;
  setFilters: (filters: FiltersState) => void;
  isBatchApprovalRequired: boolean;
};

export const BatchesHeader = ({
  filters,
  setFilters,
  isBatchApprovalRequired
}: Props) => {
  return (
    <div className="w-full items-center">
      <div className="mb-6 flex h-10 w-full flex-row justify-between">
        <div
          className="pb-7 text-2xl font-medium"
          data-testid={BATCHES_TITLE_TEST_ID}
        >
          Batches
        </div>
      </div>
      <BatchesFilters
        isBatchApprovalRequired={isBatchApprovalRequired}
        filters={filters}
        setFilters={setFilters}
      />
    </div>
  );
};
